export default __webpack_public_path__ + "static/media/fea27f48b7ecde0418a55dd78a742a1d.svg";